var camweara_key = "",
  skus_non_tryon = [],
  mainsku,
  pageData,
  skudata,
  BuyNowEnable = true,
  productIdShopify,
  shopifySearch,
  recommendedSkus = "",
  prodRecommendation,
  productCategory,
  bynowCallback,
  calledloadtryonfun = 0,
  loadfirstTimeOnly,
  pageHasBeenLoaded,
  checkCloseTryonPopUp,
  camwearaRegionID = 0,
  frameWidth = '',
  cacheNum,               //to clear cdn cache using temporary characters
  carat = "",
  dshape;                 //diamond shape

const isEditor = typeof window !== 'undefined' && Boolean(window.Shopify && window.Shopify.designMode);

var camwearaBucketArray = [
  'https://camweara-customers.s3.ap-south-1.amazonaws.com', 
  'https://storage1.camweara.com',
  'https://virginia-bucket-camweara.s3.amazonaws.com',
];

// RockHer: the Font Awesome stylesheet injection was removed; the buttons use inline SVG icons.

// Editor warning banner for Theme Customizer
function showEditorWarning(messageHtml) {
  if (!isEditor) return;
  const existing = document.getElementById('camweara-sku-warning');
  if (existing) return;

  const warning = document.createElement('div');
  warning.id = 'camweara-sku-warning';
  warning.style.cssText = 'background:#FFF3CD;color:#856404;border:1px solid #FFEEBA;padding:6px 10px;border-radius:4px;font-size:12px;margin:6px 0;display:inline-flex;align-items:center;gap:6px;z-index:9;position:relative;';
  warning.innerHTML = `
    <span>⚠️</span>
    <span>${messageHtml}</span>
    <button type="button" style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;margin-left:auto;color:#856404;" onclick="this.parentElement.style.display='none'">&times;</button>
  `;
  const btn = document.getElementById('tryonButton') || document.getElementById('MB_tryonButton');
  if (btn && btn.parentNode) {
    btn.parentNode.insertBefore(warning, btn);
  }
}

function onTryonClick(psku, companyname, frameWidthParam) {
  if (!psku) psku = mainsku;
  console.log("try on: " + psku);
  psku = psku.includes("--MB") ? psku.replace("--MB", "") : psku;
  psku = encodeURIComponent(psku);

  if (!camweara_key) camweara_key = companyname;

  let activeFrameWidth = (frameWidthParam != null && frameWidthParam !== "null" && frameWidthParam !== "")
    ? frameWidthParam
    : frameWidth;

  let urlNew = "https://cdn.camweara.com/camweara_virtual_tryon/?skus=";

  if (productCategory && productCategory.includes("electronics")) {
    urlNew = "https://cdn.camweara.com/camweara_electronics?skus=";
  }
  else if (productCategory && productCategory.includes("clothes_skus")) {
    urlNew = "https://cdn.camweara.com/clothing_virtual_tryon?skus=";
  }
  else if (productCategory && productCategory.includes("diamond")) {
    urlNew = "https://cdn.camweara.com/camweara_diamond?";
  }
  else if (productCategory && productCategory.includes("clothes2d_skus")) {
    urlNew = "https://cdn.camweara.com/clothes_genai_tryon/?skus=";
  }
  else if (productCategory && productCategory.includes('wig2d_skus')) {
    urlNew = 'https://cdn.camweara.com/wig-virtual-tryon/?skus=';
  }

  if (typeof BuyNowEnable == "undefined" || BuyNowEnable == "true") {
    urlNew = recommendedSkus
      ? urlNew + psku + "," + recommendedSkus.replace(psku + ",", "") + "&company_name=" + camweara_key
      : urlNew + psku + "&company_name=" + camweara_key;
  } else {
    urlNew = recommendedSkus
      ? urlNew + psku + "," + recommendedSkus.replace(psku + ",", "") + "&company_name=" + camweara_key + "&buynow=0"
      : urlNew + psku + "&company_name=" + camweara_key + "&buynow=0";
  }

  if (prodRecommendation) {
    urlNew = urlNew + "&product_recommendation=" + prodRecommendation;
  }

  if (activeFrameWidth != null && activeFrameWidth !== "null" && activeFrameWidth !== "") {
    urlNew = urlNew + "&frame_width=" + activeFrameWidth;
  }

  if (cacheNum != null) {
    urlNew = urlNew + "&temp=" + cacheNum;
  }

  if (carat.length > 0) {
    urlNew = urlNew + "&carat=" + carat + "&dshape=" + dshape;
  }

  let iframe = document.getElementById("iFrameID");
  if (!iframe) {
    addTryOnIframe();
    iframe = document.getElementById("iFrameID");
  }
  iframe.setAttribute("src", urlNew);
  iframe.style.display = "block";
}

function addTryOnEventListener() {
  window.addEventListener('message', tryonEventHandler);
}

function tryonEventHandler(event) {
  if (
    ~event.origin.indexOf("https://cdn.camweara.com") &&
    !(typeof event.data === "string" && event.data.includes("UserID"))
  ) {
    if (event.data == "closeIframe") {
      let iframe = document.getElementById("iFrameID");
      if (iframe) {
        iframe.setAttribute("src", "");
        iframe.style.display = "none";
      }
    } else if (typeof event.data === "object" && event.data !== null && event.data.type === "buynowShopify") {
      let iframe = document.getElementById("iFrameID");
      if (checkCloseTryonPopUp === "true" && iframe) {
        iframe.setAttribute("src", "");
        iframe.style.display = "none";
      }
      let skuBuynow = event.data.sku;
      let productIndex = event.data.productIndex;

      if (bynowCallback) {
        window[bynowCallback](skuBuynow, productIndex);
      } else if (typeof productIdShopify !== "undefined" && productIdShopify !== null) {
        let pids = String(productIdShopify).split(",");
        let selectedPid = (productIndex !== undefined && pids[productIndex]) ? pids[productIndex].trim() : pids[0].trim();
        window.open(
          `https://${camweara_key}.myshopify.com/cart/add?id=${selectedPid}`,
          `${checkCloseTryonPopUp === "true" ? "_self" : "_blank"}`
        );
      } else if (shopifySearch) {
        window.open(
          `https://${camweara_key}.myshopify.com/search?type=product&q=variants.sku:${skuBuynow}`,
          `${checkCloseTryonPopUp === "true" ? "_self" : "_blank"}`
        );
      }
    } else if (typeof event.data == "string" && event.data.includes("buynow")) {
      let iframe = document.getElementById("iFrameID");
      if (checkCloseTryonPopUp === "true" && iframe) {
        iframe.setAttribute("src", "");
        iframe.style.display = "none";
      }
      let skuBuynow = event.data.substring(7, event.data.length);
      if (bynowCallback) {
        window[bynowCallback](skuBuynow);
      } else if (typeof productIdShopify !== "undefined") {
        window.open(
          `https://${camweara_key}.myshopify.com/cart/add?id=${productIdShopify}`,
          `${checkCloseTryonPopUp === "true" ? "_self" : "_blank"}`
        );
      } else if (shopifySearch) {
        window.open(
          `https://${camweara_key}.myshopify.com/search?type=product&q=variants.sku:${skuBuynow}`,
          `${checkCloseTryonPopUp === "true" ? "_self" : "_blank"}`
        );
      }
    } else if (event.data == "requestParentUrl") {
      event.source.postMessage(
        { type: "requestParentUrl", url: window.location.href },
        event.origin
      );
      return;
    }

    if (checkCloseTryonPopUp === "true") {
      removeTryOnIframe();
    }
    addTryOnIframe();
  }
}

async function loadTryOnButton(data) {
  var page = data?.page,
    psku = data?.psku && data.psku?.main ? data.psku.main : data?.psku,
    nonTryOnProductsReport = data?.nonTryOnProductsReport || false,
    company = data?.company,
    appendButton = data?.appendButton ? data.appendButton : "default",
    prependButton = data?.prependButton ? data.prependButton : "default",
    MBappendButton = data?.MBappendButton ? data.MBappendButton : null,
    MBprependButton = data?.MBprependButton ? data.MBprependButton : null,
    styles = data?.styles,
    tryonButtonData = data?.tryonButtonData || null,
    MBtryonButtonData = data?.MBtryonButtonData || null;

  prodRecommendation = data?.prodRecommendation ? data.prodRecommendation : false;
  recommendedSkus = data?.psku ? data.psku.recommendedSkus : null;
  BuyNowEnable = data?.buynow ? data.buynow.enable : null;
  productIdShopify = data?.buynow ? data.buynow.productIdShopify : null;
  shopifySearch = data.buynow ? data.buynow.searchProduct : null;
  bynowCallback = data?.buynowCallback;
  productCategory = data?.productCategory ? data.productCategory : '';
  checkCloseTryonPopUp = BuyNowEnable && data.buynow.closeTryOnPopup ? data.buynow.closeTryOnPopup : "true";
  camwearaRegionID = data?.regionId ? data?.regionId : 0;
  frameWidth = data?.frameWidth ? data.frameWidth : null;
  cacheNum = data?.cacheNum ? data.cacheNum : null;
  carat = data?.carat ? data.carat : '';
  dshape = data?.dshape ? data.dshape : null;

  if (
    recommendedSkus &&
    (recommendedSkus.includes("[") || recommendedSkus.includes("]") || Array.isArray(recommendedSkus))
  ) {
    recommendedSkus = recommendedSkus.toString().replace(/^[\[]|[\]]$/g, "");
    recommendedSkus = trimString(recommendedSkus);
  }

  pageData = page ? page.toLowerCase() : "product";
  Addstyles(styles);
  if (company) camweara_key = company;
  mainsku = psku;
  psku = psku?.id ? psku.id : mainsku;

  if (!document.querySelector("#iFrameID")) {
    addTryOnIframe();
    addAnalyticsSnippets();
    addTryOnEventListener();
  }

  let tryonSkusJson = "";
  try {
    if (!localStorage.getItem("tryonSkusData") || !loadfirstTimeOnly) {
      loadfirstTimeOnly = "loaded";
      sessionStorage.setItem("pageHasBeenLoaded", "true");
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      today = dd + mm + yyyy;

      let tryonJsonUrl = camwearaBucketArray[camwearaRegionID] + `/${camweara_key}/`;
      let tryon_file_url = `${tryonJsonUrl}${camweara_key || company}_tryonbutton.json?${today}${Math.random()}`;
      let response = await fetch(tryon_file_url);
      if (response && response.ok) {
        tryonSkusJson = await response.json();
        localStorage.setItem("tryonSkusData", JSON.stringify(tryonSkusJson));
      }
    } else {
      tryonSkusJson = JSON.parse(localStorage.getItem("tryonSkusData"));
    }
  } catch (err) {
    console.warn("Could not fetch try-on json:", err);
  }

  RenderButton(
    pageData,
    tryonSkusJson || {},
    window.innerWidth >= 650 ? "desktop" : "mobile",
    appendButton,
    prependButton,
    MBprependButton,
    MBappendButton,
    company,
    psku,
    page,
    tryonButtonData,
    nonTryOnProductsReport,
    skus_non_tryon,
    MBtryonButtonData,
    styles
  );
}

function RenderButton(
  page,
  tryonSkusJson,
  renderType,
  appendButton,
  prependButton,
  MBprependButton,
  MBappendButton,
  company,
  psku,
  pageOrig,
  tryonButtonData,
  nonTryOnProductsReport,
  skus_non_tryon,
  MBtryonButtonData,
  styles
) {
  Addstyles(styles);

  let skuPosInJson = checkSkuLocation(tryonSkusJson, psku) || [];
  if (!productCategory || productCategory === '') {
    productCategory = skuPosInJson[0] || 'jewelry_skus';
  }

  const hasSku = skuPosInJson.length > 0 || (carat && carat.length > 0);

  if (hasSku || isEditor) {
    if (hasSku) {
      console.log("try on: " + (mainsku || psku));
    } else {
      console.log("try on: " + (mainsku || psku || "N/A") + " (SKU not in dashboard, previewing in Theme Editor)");
    }
    let buttonID,
      buttonClassName,
      buttonIcon,
      buttonText,
      appendButtonSelector,
      prependButtonSelector;

    if (renderType === "mobile") {
      buttonID = page == "listing"
        ? `MB--${(psku || "").replace(/[^A-Za-z0-9]/g, "")}--MB`
        : "MB_tryonButton";

      buttonClassName = "MB_tryonButton";
      buttonIcon = MBtryonButtonData ? MBtryonButtonData.faIcon : tryonButtonData && tryonButtonData.faIcon;
      buttonText = MBtryonButtonData ? MBtryonButtonData.text : tryonButtonData && tryonButtonData.text;

      appendButtonSelector = MBappendButton
        ? MBappendButton.id
          ? "#" + MBappendButton.id
          : MBappendButton.class
            ? "." + MBappendButton.class.replace(/\s/g, ".")
            : 'form[action="/cart/add"]'
        : appendButton.id
          ? "#" + appendButton.id
          : appendButton.class
            ? "." + appendButton.class.replace(/\s/g, ".")
            : 'form[action="/cart/add"]';

      prependButtonSelector = MBprependButton
        ? MBprependButton.id
          ? "#" + MBprependButton.id
          : MBprependButton.class
            ? "." + MBprependButton.class.replace(/\s/g, ".")
            : 'form[action="/cart/add"]'
        : prependButton.id
          ? "#" + prependButton.id
          : prependButton.class
            ? "." + prependButton.class.replace(/\s/g, ".")
            : 'form[action="/cart/add"]';

    } else {
      buttonID = page == "listing"
        ? `tryon-${(psku || "").replace(/[^A-Za-z0-9]/g, "")}`
        : "tryonButton";

      buttonClassName = "tryonButton";
      buttonIcon = tryonButtonData && tryonButtonData.faIcon;
      buttonText = tryonButtonData && tryonButtonData.text;

      appendButtonSelector = appendButton.id
        ? "#" + appendButton.id
        : appendButton.class
          ? "." + appendButton.class.replace(/\s/g, ".")
          : 'form[action="/cart/add"]';

      prependButtonSelector = prependButton.id
        ? "#" + prependButton.id
        : prependButton.class
          ? "." + prependButton.class.replace(/\s/g, ".")
          : 'form[action="/cart/add"]';
    }

    let buttonData = {
      id: buttonID,
      dataId: psku,
      dataSKU: psku,
      companyName: company,
      frameWidth: frameWidth,
      className: buttonClassName,
      icon: buttonIcon,
      text: buttonText,
    };

    let buttonHtml = generateButton(buttonData);
    let checkButton = document.getElementById(buttonID);

    const localContainer = document.getElementById("camweara-tryon-container") || document.getElementById("camweara-tryon-wrapper");
    if (localContainer) {
      checkButton && checkButton.remove();
      localContainer.innerHTML = buttonHtml;
    } else if (prependButtonSelector && prependButton !== "default" && document.querySelector(prependButtonSelector)) {
      checkButton && checkButton.remove();
      document.querySelector(prependButtonSelector).insertAdjacentHTML("beforebegin", buttonHtml);
    } else if (appendButtonSelector && appendButton !== "default" && document.querySelector(appendButtonSelector)) {
      checkButton && checkButton.remove();
      document.querySelector(appendButtonSelector).insertAdjacentHTML("afterend", buttonHtml);
    } else if (prependButtonSelector && document.querySelector(prependButtonSelector)) {
      checkButton && checkButton.remove();
      document.querySelector(prependButtonSelector).insertAdjacentHTML("beforebegin", buttonHtml);
    } else if (appendButtonSelector && document.querySelector(appendButtonSelector)) {
      checkButton && checkButton.remove();
      document.querySelector(appendButtonSelector).insertAdjacentHTML("afterend", buttonHtml);
    }

    const createdBtn = document.getElementById(buttonID);
    if (createdBtn) {
      createdBtn.style.display = "flex";
      createdBtn.style.alignItems = "center";
      createdBtn.style.justifyContent = "center";
      createdBtn.style.gap = "6px";
    }

    if (isEditor && !hasSku) {
      showEditorWarning(`SKU "<strong>${psku || 'N/A'}</strong>" not in Camweara catalog. (Visible here in Theme Editor for layout preview)`);
    }
  } else {
    console.log("try on: " + (mainsku || psku || "N/A") + " (SKU not in dashboard, button not rendered)");
  }
}

function generateButton(data) {
  if (!data) return "";

  var id = data.id || "";
  var className = data.className || "";
  var icon = data.icon || "";
  var companyName = data.companyName || "";
  var dataSKU = data.dataSKU || "";
  var text = data.text || "Virtual Try On";
  var fw = data.frameWidth || null;

  var safeDataSKU = String(dataSKU).replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, "&quot;");
  var safeCompany = String(companyName).replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, "&quot;");
  var safeFrameWidth = (fw != null && fw !== "null") ? String(fw).replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, "&quot;") : "";

  var onClick = "onTryonClick('" + safeDataSKU + "','" + safeCompany + "','" + safeFrameWidth + "');";
  var iconTemplate = "";
  if (icon && icon !== "disable") {
    if (typeof icon === "string" && icon.trim().startsWith("<svg")) {
      iconTemplate = icon;
    } else {
      iconTemplate = '<i class="' + icon + '"></i>';
    }
  }

  return `
    <button 
      type="button" 
      id="${id}" 
      class="${className}" 
      style="display:none;"
      onclick="${onClick}"
    >
      ${iconTemplate}&nbsp;${text}
    </button>
  `;
}

function Addstyles(data) {
  let tryonbutton = data?.tryonbutton,
    iFrameID = data?.iFrameID,
    MBtryonbutton = data?.MBtryonbutton,
    MBiFrameID = data?.MBiFrameID,
    tryonbuttonHover = data?.tryonbuttonHover,
    MBtryonbuttonHover = data?.MBtryonbuttonHover;

  let defaultTryonButtonStyle = `
    background: #ffffff;
    color: #000000;
    border: 1px solid #000000;
    border-radius: 0px;
    padding: 0px 10px;
    margin: 10px 5px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    cursor: pointer;
    transition: 0.2s;
    white-space: nowrap;
    z-index: 2;
  `;

  let defaultIframeStyles = `
    opacity: 1;
    background-color: transparent;
    position: fixed;
    width: 100%;               
    height: 100%;                  
    top: 0px;
    left: 0px;
    margin: 0px;
    z-index: 2147483647 !important;
    border: none;
    overflow: hidden;
  `;

  const productStyles = `
  <style id="tryon-product-styles">
    #tryonButton {
      ${defaultTryonButtonStyle}
      ${convertToStyles(tryonbutton)}
    }
    #MB_tryonButton {
      ${defaultTryonButtonStyle}
      ${convertToStyles(tryonbutton)}
      ${convertToStyles(MBtryonbutton)}
    }
    #iFrameID {
      ${defaultIframeStyles}
      ${convertToStyles(iFrameID)}
    }
    #tryonButton:hover {
      ${convertToStyles(tryonbuttonHover)}
    }
    @media(max-width: 480px) {
      #iFrameID {
        ${defaultIframeStyles}
        ${convertToStyles(MBiFrameID)}
      }
      #MB_tryonButton:hover {
        ${convertToStyles(tryonbuttonHover)}
        ${convertToStyles(MBtryonbuttonHover)}
      }
    }
  </style>`;

  if (!document.querySelector("#tryon-product-styles")) {
    document.querySelector("head").insertAdjacentHTML("afterbegin", productStyles);
  }
}

function convertToStyles(data) {
  if (!data) return "";
  if (data.fontFamily) {
    data.fontFamily = data.fontFamily.toLowerCase();
  }
  return JSON.stringify(data)
    .replace(/[{}"']/g, "")
    .replace(/,/g, ";")
    .replace(/[A-Z]/g, (s) => "-" + s.toLowerCase()) + ";";
}

// GTM Analytics function disabled: GTM-P9FG4SV removed as requested
function addAnalyticsSnippets() {
  // GTM injection completely disabled for RockHer
}

function trimString(stringInput, maxLength = 50) {
  if (typeof stringInput != "undefined") {
    let skusArray = stringInput.split(",");
    if (skusArray.length > maxLength) {
      skusArray = skusArray.splice(0, maxLength);
    }
    return skusArray.join(",");
  }
  return "";
}

function addTryOnIframe() {
  if (!document.querySelector("#iFrameID")) {
    document.querySelector("body").insertAdjacentHTML(
      "afterend",
      '<iframe id="iFrameID" allow="camera *; web-share;" src="about:blank" style="display:none;"></iframe>'
    );
  }
}

function removeTryOnIframe() {
  let iframeEl = document.getElementById("iFrameID");
  if (iframeEl && iframeEl.parentNode) {
    iframeEl.parentNode.removeChild(iframeEl);
  }
}

function checkSkuLocation(tryonSkusJson, psku) {
  if (!tryonSkusJson || !psku) return null;
  try {
    const result = [];
    const skuList = Array.isArray(psku)
      ? psku
      : String(psku).split(',').map(s => s.trim());

    for (const s of skuList) {
      if (!s) continue;
      const target = s.toLowerCase();
      for (const [key, value] of Object.entries(tryonSkusJson)) {
        if (Array.isArray(value) && value.some(v => v && v.trim().toLowerCase() === target)) {
          if (!result.includes(key)) result.push(key);
          if (!mainsku) mainsku = s;
        }
      }
    }
    return result.length ? result : null;
  } catch (error) {
    console.error('Error in checkSkuLocation:', error);
    return null;
  }
}

if (typeof window !== 'undefined') {
  window.loadTryOnButton = loadTryOnButton;
  window.onTryonClick = onTryonClick;
}